"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(key, persistedItem, newValue) {
    let persist;
    try {
        persist = persistedItem ? JSON.parse(persistedItem) : {};
    }
    catch (err) {
        console.error(err);
        persist = {};
    }
    return JSON.stringify(Object.assign(persist, {
        [key]: newValue,
    }));
}
exports.default = default_1;
//# sourceMappingURL=get-new-item.js.map